module.exports = __webpack_public_path__ + "static/use-case-2-content-2-02266df3689dba7ed96c38adb3625232.png";